document.addEventListener("DOMContentLoaded", function(){

const sticky = document.getElementById("toquiSticky");
const stickyBtn = document.querySelector(".sticky-add-cart");

if(!sticky || !stickyBtn) return;

function getRealButton(){
return document.querySelector('button[name="add"]');
}

function toggleSticky(){

const realBtn = getRealButton();

if(!realBtn) return;

const rect = realBtn.getBoundingClientRect();

if(rect.bottom < 0){
sticky.classList.add("show");
}else{
sticky.classList.remove("show");
}

}

window.addEventListener("scroll", toggleSticky, { passive:true });

stickyBtn.addEventListener("click", function(){

const realBtn = getRealButton();

if(realBtn){
realBtn.click();
}

});

});

/* TOQUI PRODUCT GALLERY FIX */

document.addEventListener("DOMContentLoaded", function(){

const thumbnails = document.querySelectorAll(".thumbnail");
const slides = document.querySelectorAll(".product__media-item");

if(!thumbnails.length || !slides.length) return;

thumbnails.forEach(function(thumb){

thumb.addEventListener("click", function(e){

e.preventDefault();

const target = thumb.closest("li").dataset.target;

slides.forEach(function(slide){
slide.classList.remove("is-active");
});

const activeSlide = document.querySelector('[data-media-id="'+target+'"]');

if(activeSlide){
activeSlide.classList.add("is-active");
}

thumbnails.forEach(t => t.removeAttribute("aria-current"));
thumb.setAttribute("aria-current","true");

});

});

});